import { appCounterStore } from "@/store/app";
import { permissionStore } from "@/store/permission";
import { useCounterStore } from "@/store/user";
import { getQueryParam } from "@/utils";
import { getCluster, getRoles, getToken } from "@/utils/auth";
import router from "./index";
const whiteList = ["login", "modifyPassword", "about", "faceAuth"];
router.beforeEach(async (to, from, next) => {
    const permission_store = permissionStore();
    const appStore = appCounterStore();
    const useStore = useCounterStore();
    const hasToken = getToken();
    if (hasToken) {
        const roles = getRoles();
        if (getCluster()) {
            useStore.searchRunningCluster(getCluster());
        }
        if (roles[0] === "sub") {
            await permission_store.fetchSubPermissions();
        }
        if (permission_store.getAddRoutes.length === 0) {
            const accessRoutes = await permission_store.generateRoutes(roles);
            for (const i of accessRoutes) {
                router.addRoute(i);
            }
            next({ ...to, replace: true });
        }
        else {
            const redirect_url = getQueryParam("redirect_url");
            const loginState = appStore.getLoginState;
            if (loginState === "already") {
                if (getQueryParam("redirect_url")) {
                    appStore.setLoginState("login");
                }
                if (to.path === "/login" && !redirect_url) {
                    next("/");
                }
                else {
                    next();
                }
            }
            else {
                if (whiteList.indexOf(to.name) !== -1) {
                    next();
                }
                else {
                    next(`/login`);
                }
            }
        }
    }
    else {
        appStore.setLoginState("login");
        if (whiteList.indexOf(to.name) !== -1) {
            next();
        }
        else {
            next(`/login?redirect=${encodeURIComponent(to.fullPath)}`);
        }
    }
});
